<template>
  <el-dialog
    :visible.sync="showModal"
    :center="true"
    :modal="showBackdrop"
    class="unsubscribe-modal"
    custom-class="unsubscribe-modal"
    append-to-body
    @closed="emitEvent"
  >
    <div
      class="adyen-unsubscribe"
      data-test="modal-unsubscribe">
      <h5 class="adyen-unsubscribe__title">Switch to free</h5>
      <p class="m-b">By switching to free you are canceling your Luminary Premium subscription and you will no longer be able to listen to Premium content or ad-free exclusives after the end of this billing cycle.</p>
      <p class="m-b-0">Are you sure you want to switch?</p>
      <div class="adyen-unsubscribe__buttons">
        <el-button
          :disabled="loading"
          class="btn-transparent cancel-button"
          @click="ignore"
        >
          Not now
        </el-button>
        <el-button
          v-loading="loading"
          class="action-button"
          type="primary"
          data-test="btn-switchtofree"
          @click="cancel"
        >
          Yes, switch to free
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import Subscription from '../../services/Subscription';

export default {
  name: 'AdyenUnsubscribeModal',
  props: {
    show_modal: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      showModal: this.show_modal,
      showPaymentForm: false,
      subscriptionProvider: new Subscription(),
      loading: false,
    };
  },
  computed: {
    isSubscribed() {
      return this.$store.getters.user.is_subscribed;
    },
    showBackdrop() {
      const width = window.innerWidth;
      return width > 567;
    },
  },
  watch: {
    show_modal(newVal) {
      this.showModal = newVal;
    },
  },
  methods: {
    emitEvent() {
      this.showPaymentForm = false;
      this.$emit('close');
    },
    showAdyenForm() {
      this.showPaymentForm = true;
    },
    closeModal() {
      this.$emit('close');
    },
    cancel() {
      this.loading = true;
      this.subscriptionProvider
        .cancelSubscription()
        .then((resp) => {
          this.loading = false;
          this.$store.dispatch('setSubscriptionId', '');
          if (resp && !resp.is_provisional_subscription) {
            this.$store.commit('setUserSubscription', resp);
            // const { user } = this.$store.getters;
            this.showSuccessMsg('Successfully downgraded to Luminary Free');
            // this.$store.commit('setUser', user);
            this.$analytics.track('ga_subscription_cancelled');
            this.$emit('close', true);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.showErrorMsg(error);
        });
    },
    ignore() {
      this.$emit('close', false);
    },
  },
};
</script>
<style lang="scss">
@import '../../assets/scss/variables.scss';

.unsubscribe-modal.el-dialog {
  .el-dialog__header{
    padding: 0px;
    .el-dialog__close.el-icon.el-icon-close {
      font-size: 24px;
    }
  }

  @media (max-width: 767px) {
    width: 70%;
  }

  @media (max-width: 567px) {
    width: 85%;
  }

  .el-dialog__body{
    padding: 50px 100px;

    @media (max-width: 1000px) {
      padding: 25px 50px;
    }

    @media (max-width: 767px) {
      border-radius: 0;
    }
  }

  .adyen-unsubscribe {
    text-align: left;

    &__title {
      font-family: "ITC Clearface";
      font-size: 24px;
      line-height: 28px;
      margin-top: 0;
      color: $black;
    }

    &__buttons {
      margin-top: 28px;

      display: flex;

      @media (max-width: 567px) {
        flex-direction: column;

        > button {
          &:last-child {
            margin: 15px 0 0 0;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// app/src/components/subscription/DowngradeModal.vue